module.exports = __webpack_public_path__ + "img/bigwin-text.ecdb2a2f.png";